export default __webpack_public_path__ + "static/PPGoshaSans-Bold-a90788303976b9c22fa08633ab8b81eb.eot";